import { render } from "./daffc-vocationals.vue?vue&type=template&id=10f5146b"
import script from "./daffc-vocationals.vue?vue&type=script&lang=js"
export * from "./daffc-vocationals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__